import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createGame } from '../api/gameApi';
import './Home.css';

function Home() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [gameIdInput, setGameIdInput] = useState('');

  async function handleRandomGame() {
    setIsLoading(true);
    try {
      const data = await createGame();
      navigate(`/game?id=${data.gameId}`);
    } catch (err) {
      alert('Error creating game: ' + err.message);
      setIsLoading(false);
    }
  }

  async function handleDailyChallenge() {
    // Navigate to daily challenge game
    navigate('/game?mode=daily');
  }

  function handleLoadGame() {
    if (gameIdInput.trim()) {
      navigate(`/game?id=${gameIdInput.trim()}`);
    }
  }

  return (
    <div className="home-container">
      <div className="home-content">
        <div className="logo">
          <img src="/icons/Icon-192.png" alt="PhenoGuessr Logo" />
        </div>

        <h1>PhenoGuessr</h1>
        <h2>An Educational Geography Game</h2>

        <p className="description">
          PhenoGuessr is an interactive geography game that challenges you to identify the geographic
          origins of human phenotypes. Test your knowledge of world populations, improve your understanding
          of human diversity, and learn about global demographics through engaging gameplay. Each round
          presents facial features from different regions, and you must pinpoint their location on an
          interactive world map.
        </p>

        <div className="button-group">
          <button
            className="primary-button"
            onClick={handleRandomGame}
            disabled={isLoading}
          >
            {isLoading ? 'Creating Game...' : 'Start Random Game'}
          </button>

          <button
            className="secondary-button"
            onClick={handleDailyChallenge}
            disabled={isLoading}
          >
            Daily Challenge
          </button>
        </div>

        <div className="load-game-section">
          <p>Have a game code?</p>
          <div className="load-game-input">
            <input
              type="text"
              placeholder="Enter game ID"
              value={gameIdInput}
              onChange={(e) => setGameIdInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleLoadGame()}
            />
            <button onClick={handleLoadGame}>Load Game</button>
          </div>
        </div>

        <div className="features">
          <div className="feature">
            <h3>🌍 Learn Geography</h3>
            <p>Discover how human populations vary across different regions of the world</p>
          </div>
          <div className="feature">
            <h3>🎯 Test Your Knowledge</h3>
            <p>Challenge yourself with 10 rounds of phenotype identification</p>
          </div>
          <div className="feature">
            <h3>📊 Track Your Score</h3>
            <p>Compete with friends and see who knows world geography best</p>
          </div>
        </div>

        <footer className="home-footer">
          <a href="/about">About</a>
          <span>•</span>
          <a href="/privacy">Privacy Policy</a>
        </footer>
      </div>
    </div>
  );
}

export default Home;
